import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  isLaborReport: false,
  loading: false,
};

export const getLaborReportReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.GET_LABOR_REPORT_SUCCESS: {
      return {
        ...state,
        isLaborReport: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case laborHoursConstant.GET_LABOR_REPORT_FAILURE:
      return {
        ...state,
        isLaborReport: false,
        response: action.payload,
        loading: false,
      };

    case laborHoursConstant.GET_LABOR_REPORT_LOADER:
      return {
        ...state,
        loading: true,
      };

    case laborHoursConstant.GET_LABOR_REPORT_RESET:
      return intitialstate;

    default:
      return state;
  }
};
